export default __webpack_public_path__ + "static/media/Crown Plaza.3b18baa0.jpg";